import React, { FC } from 'react';
import styled from 'styled-components';

import { Dialog, buttonVariants } from '@clatter/ui';
import { NgButton } from '../UI';
import { CircularLoader } from '../../shared';

const StyledContainer = styled.div`
  height: 90%;
  overflow: auto;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 20vh;
  min-width: 50vw;

  gap: 2rem;

  .dialog-content {
    padding: 0;
  }

  .dialog-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .custom-buttons {
    display: flex;
    gap: 1rem;
  }
`;

const defaultButtons = ({ cancelBtnCallback }: { cancelBtnCallback: () => void }): IButtonDef[] => [
  {
    label: 'Cancel',
    type: 'reset',
    variant: buttonVariants.clear,
    callback: cancelBtnCallback,
  },
  {
    label: 'Ok',
    type: 'submit',
    variant: buttonVariants.primary,
  },
];

const RenderButton: FC<IButtonDef> = ({ label, data, type = 'button', variant, isLoading, callback }) => {
  const handleClick = () => {
    if (callback) {
      if (typeof callback !== 'function') {
        console.error('Provided callback is not a function');
        return;
      }
      callback(data);
    }
  };

  return (
    <NgButton type={type} onClick={handleClick} variant={variant} disabled={isLoading}>
      {label}
    </NgButton>
  );
};

export const ConfirmationDialog = ({
  dialogState,
  onDismiss,
  children,
  isLoading: isParentLoading,
}: IConfirmationDialogProps) => {
  const handleDialogDismiss = (data: any) => {
    onDismiss(null);
  };

  if (!dialogState.opened) {
    return null;
  }

  return (
    <>
      <Dialog
        title={dialogState.title}
        onCloseDialog={() => handleDialogDismiss(null)}
        open={dialogState?.opened}
        includeFooter
      >
      <StyledContainer>
        {children && dialogState?.data ? (
          React.cloneElement(children, { data: dialogState.data, handleDialogDismiss: handleDialogDismiss })
        ) : (
          <div>{dialogState.content}</div>
        )}

        {!dialogState?.hideButtons && (
          <div className="dialog-footer">
            <div>{ isParentLoading && <CircularLoader size={30} /> }</div>
            <div className="custom-buttons">
              {(dialogState.buttons || defaultButtons({ cancelBtnCallback: () => handleDialogDismiss(null) })).map(
                (buttonProps, index) => (
                  <RenderButton key={index} {...buttonProps} data={dialogState?.data}  isLoading={isParentLoading} />
                ),
              )}
            </div>
          </div>
        )}
      </StyledContainer>
      </Dialog>
    </>
  );
};
